import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-927cd86a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-5" }
const _hoisted_2 = { class: "card main-table-container card-primary card-outline" }
const _hoisted_3 = {
  key: 0,
  class: "overlay"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-2x fa-sync-alt fa-spin" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Usuarios")
], -1))
const _hoisted_7 = { class: "card-body p-0" }
const _hoisted_8 = {
  id: "example1_wrapper",
  class: "dataTables_wrapper dt-bootstrap4"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-sm-12" }
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = {
  key: 0,
  class: "position-absolute overlay w-100 h-100 mx-auto"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-2x fa-sync-alt fa-spin" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  id: "example1",
  class: "table table-bordered table-striped dataTable dtr-inline",
  role: "grid",
  "aria-describedby": "example1_info"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { role: "row" }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting sorting_asc",
      tabindex: "0",
      "aria-controls": "example1",
      rowspan: "1",
      colspan: "1",
      "aria-sort": "ascending",
      "aria-label": "Rendering engine: activate to sort column descending"
    }, " Nombre "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting",
      tabindex: "0",
      "aria-controls": "example1",
      rowspan: "1",
      colspan: "1",
      "aria-label": "Browser: activate to sort column ascending"
    }, " Correo electronico "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting",
      tabindex: "0",
      "aria-controls": "example1",
      rowspan: "1",
      colspan: "1",
      "aria-label": "Platform(s): activate to sort column ascending"
    })
  ])
], -1))
const _hoisted_17 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_18 = {
  class: "dtr-control sorting_1",
  tabindex: "0"
}
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = ["value"]
const _hoisted_21 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "dtr-control sorting_1",
    tabindex: "0",
    colspan: "100%"
  }, /*#__PURE__*/_toDisplayString(`No hay registros`))
], -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-12 col-sm-6 px-4" }
const _hoisted_27 = { class: "rol-select" }
const _hoisted_28 = { class: "form-group col" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Aplicación", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "SELECCIONA UNA APLICACIÓN", -1))
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "col px-4" }
const _hoisted_33 = { class: "rol-select" }
const _hoisted_34 = { class: "form-group col" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Permisos", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "SELECCIONA UN PERMISO", -1))
const _hoisted_37 = ["value"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "card mt-2" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Permisos seleccionados")
], -1))
const _hoisted_42 = { class: "card-body p-0" }
const _hoisted_43 = {
  id: "example1_wrapper",
  class: "dataTables_wrapper dt-bootstrap4"
}
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col-sm-12" }
const _hoisted_46 = {
  id: "example1",
  class: "table table-bordered table-striped dataTable dtr-inline",
  role: "grid",
  "aria-describedby": "example1_info"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { role: "row" }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting sorting_asc",
      tabindex: "0",
      "aria-controls": "example1",
      rowspan: "1",
      colspan: "1",
      "aria-sort": "ascending",
      "aria-label": "Rendering engine: activate to sort column descending"
    }, " Nombre "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting",
      tabindex: "0",
      "aria-controls": "example1",
      rowspan: "1",
      colspan: "1",
      "aria-label": "Platform(s): activate to sort column ascending"
    })
  ])
], -1))
const _hoisted_48 = { key: 0 }
const _hoisted_49 = {
  class: "dtr-control sorting_1",
  tabindex: "0"
}
const _hoisted_50 = { class: "text-center" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "dtr-control sorting_1",
    tabindex: "0",
    colspan: "100%"
  }, /*#__PURE__*/_toDisplayString(`No hay registros`))
], -1))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = { class: "card-footer text-center" }

export function render(_ctx, _cache) {
  const _component_pagination = _resolveComponent("pagination")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isBtnLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                  : _createCommentVNode("", true),
                _createElementVNode("table", _hoisted_15, [
                  _hoisted_16,
                  (_ctx.users && _ctx.users.length > 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            class: "odd",
                            key: index
                          }, [
                            _createElementVNode("td", _hoisted_18, _toDisplayString(user.name), 1),
                            _createElementVNode("td", null, _toDisplayString(user.email), 1),
                            _createElementVNode("td", _hoisted_19, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                value: user.id,
                                disabled: "!editMode",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.selectedUsers) = $event)),
                                onChange: _cache[1] || (_cache[1] = (...args) => (_ctx.uniqueCheck && _ctx.uniqueCheck(...args)))
                              }, null, 40, _hoisted_20), [
                                [_vModelCheckbox, _ctx.selectedUsers]
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("tbody", _hoisted_21, _hoisted_23))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_pagination, {
              modelValue: _ctx.page,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.page) = $event)),
              records: _ctx.records,
              "per-page": _ctx.perPage,
              onPaginate: _ctx.getResults
            }, null, 8, ["modelValue", "records", "per-page", "onPaginate"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _withDirectives(_createElementVNode("select", {
                class: "form-control mr-sm-2",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.applicationId) = $event)),
                onChange: _cache[4] || (_cache[4] = $event => (_ctx.getPermissionList()))
              }, [
                _hoisted_30,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applications, (application) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: application.id
                  }, _toDisplayString(application.name), 9, _hoisted_31))
                }), 256))
              ], 544), [
                [_vModelSelect, _ctx.applicationId]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.permission) = $event))
              }, [
                _hoisted_36,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permissions, (item, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: item,
                    key: index
                  }, _toDisplayString(item.name), 9, _hoisted_37))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.permission]
              ])
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-success add-rol-btn ml-2",
              onClick: _cache[6] || (_cache[6] = (...args) => (_ctx.addPermisison && _ctx.addPermisison(...args)))
            }, _hoisted_39)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _hoisted_41,
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("table", _hoisted_46, [
                  _hoisted_47,
                  (_ctx.selectedPermissions && _ctx.selectedPermissions.length > 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_48, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedPermissions, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            class: "odd",
                            key: index
                          }, [
                            _createElementVNode("td", _hoisted_49, _toDisplayString(item.name), 1),
                            _createElementVNode("td", _hoisted_50, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-danger ml-2",
                                onClick: $event => (_ctx.removePermission(index))
                              }, _hoisted_53, 8, _hoisted_51)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("tbody", _hoisted_54, _hoisted_56))
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-success",
          onClick: _cache[7] || (_cache[7] = (...args) => (_ctx.saveAsociation && _ctx.saveAsociation(...args)))
        }, " Guardar "),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-danger ml-3",
          onClick: _cache[8] || (_cache[8] = $event => (_ctx.goToUsersList()))
        }, " Cancelar ")
      ])
    ])
  ]))
}